import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getMainTranscript,
  getGenomeName,
  getShouldRenderLinksToVarsome,
  getIsFLT3ITD,
} from "../../../../state/selectors/general.selectors";
import HelperTextLabel from "../../../../components/atoms/HelperText/HelperTextLabel";
import Hgvs from "../Hgvs/Hgvs";
import ProteinValue from "../ProteinValue/ProteinValue";

const HgvsTranscript = ({ mainTranscript, isFLT3ITD }) => {
  if (mainTranscript && mainTranscript.hgvs) {
    const {
      hgvs,
      name,
      gene_symbol: geneSymbol,
      hgvs_p3: pValue,
    } = mainTranscript;
    const hgvsCdot = geneSymbol
      ? `${geneSymbol}(${name}):${hgvs}`
      : `${name}:${hgvs}`;

    return (
      <div className="varsome-horiz-flex">
        <div className="varsome-horiz-list-item">
          <HelperTextLabel label="HGVS" fieldDescriptionKey="HGVS" />
          <div className="varsome-horiz-list-value tw-whitespace-pre">
            <span className="tw-break-all tw-whitespace-break-spaces">
              <Hgvs isFLT3ITD={isFLT3ITD} hgvs={hgvsCdot} />
            </span>
            <div>
              <ProteinValue isFLT3ITD={isFLT3ITD} pValue={pValue} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

HgvsTranscript.propTypes = {
  mainTranscript: PropTypes.shape({
    name: PropTypes.string,
    strand: PropTypes.string,
    coding_impact: PropTypes.string,
    function: PropTypes.arrayOf(PropTypes.string),
    hgvs: PropTypes.string,
    hgvs_p1: PropTypes.string,
    hgvs_p3: PropTypes.string,
    location: PropTypes.string,
    coding_location: PropTypes.string,
    canonical: PropTypes.bool,
    gene_symbol: PropTypes.string,
    splice_distance: PropTypes.string,
    ensembl_support_level: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  isFLT3ITD: PropTypes.bool,
};

HgvsTranscript.defaultProps = {
  mainTranscript: null,
  isFLT3ITD: false,
};

const mapStateToProps = (state) => ({
  mainTranscript: getMainTranscript(state),
  genomeName: getGenomeName(state),
  shouldRenderLinksToVarsome: getShouldRenderLinksToVarsome(),
  isFLT3ITD: getIsFLT3ITD(state),
});

export default connect(mapStateToProps)(HgvsTranscript);
